import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-home\"><path d=\"M910.222222 540.444444v455.111112H597.333333v-199.111112h-170.666666v199.111112H113.777778V512H0L512 28.444444l512 512h-113.777778zM142.222222 455.111111h28.444445v483.555556h199.111111v-199.111111h284.444444v199.111111h199.111111V483.555556h28.444445L512 113.777778 142.222222 455.111111z\" fill=\"#666666\" p-id=\"1480\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol